<template>
  <page>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New GL Mapping
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-btn color="primary" dark class=" mr-2" @click="pickFile">
          Upload GL Interface Record
          <v-icon right>mdi-upload</v-icon>
        </v-btn>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :footer-props="{'items-per-page-options': itemsPerPage }"
        v-bind:options.sync="pagination"
        item-key="name"
        :loading="loading"
        :no-data-text="noDataText"
        :custom-filter="customSearch"
      >
        <template v-slot:item="row"
          ><tr>
            <td class="text-xs-left">{{ row.item.glapplnInt }}</td>
            <td class="text-xs-left">{{ row.item.desc }}</td>
            <td class="table-action-header">
              <table-action
                review
                @review="doReview(row.item.glapplnInt)"
                query
                @query="doQuery(row.item.glapplnInt)"
                remove
                @remove="doPromptRemove(row.item)"
              ></table-action>
            </td></tr
        ></template>
      </v-data-table>
      <input type="file" ref="file" accept=".csv" v-show="false" @change="validateFile" />
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected GL Mapping and all related GL interface?</p>
        <div class="title">{{ selectedGLMapping.glapplnInt }} - {{ selectedGLMapping.desc }}</div>
      </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { glAppInterface } from '@/const/acct/glAcct'
export default {
  data() {
    return {
      headers: [{ text: 'GL Application Interface', value: 'glapplnInt' }, { text: 'Description', value: 'desc' }, TableConst.tableActionHeader],
      file: null,
      selectedGLMapping: {
        glapplnInt: null,
        desc: null
      },
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.glMappingList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          this.items = []
          if (result) {
            const { data } = result.data
            if (data) {
              data.map((glMapping) => {
                const convertList = {
                  glapplnInt: glMapping.glapplnInt,
                  desc: glAppInterface[glMapping.glapplnInt]
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedGLMapping = data
      }
    },
    doDelete() {
      if (this.selectedGLMapping) {
        const apiURI = this.menu.deleteGlMapping
        if (apiURI) {
          this.$http
            .delete(expandURI(apiURI, { glapplnInt: this.selectedGLMapping.glapplnInt }))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.doInit()
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    doNew() {
      this.$router.push({
        name: 'mapFactor',
        params: {
          glapplnInt: 'new'
        }
      })
    },
    doReview(data) {
      this.$router.push({
        name: 'mapFactor',
        params: {
          glapplnInt: data
        }
      })
    },
    doQuery(data) {
      this.$router.push({
        name: 'qMapFactor',
        params: {
          glapplnInt: data
        }
      })
    },
    pickFile() {
      this.$refs.file.value = ''
      this.$refs.file.click()
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    async validateFile() {
      await this.getFile(event)
      if (this.file) {
        const fileReader = new FileReader()
        fileReader.onload = async () => {
          const firstCell = fileReader.result.split('\n')[0].split(',')[0]
          if (firstCell.toLowerCase() === 'upload interface records') {
            this.doUpload()
          } else {
            this.$toast.error('Excel sheet not for upload')
          }
        }
        fileReader.readAsText(this.file)
      } else {
        this.$toast.error('Excel sheet not for upload')
      }
    },
    async doUpload() {
      const apiURI = this.menu.uploadGlInt
      if (apiURI) {
        try {
          const formData = new FormData()
          formData.append('file', this.file, this.file.name)
          const result = await this.$http.post(apiURI, formData)
          const data = result.data
          this.notify(data)
        } catch (err) {
          const result = err.response
          const { data } = result.data
          if (data) {
            this.fieldMessage(data)
            this.message(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
